import {useCallback, useState} from 'react'

export const usePopupScreen = () => {
  const [isPopupScreenVisible, setIsPopupScreenVisible] = useState(false)

  const onOpenPopupScreen = useCallback(() => {
    setIsPopupScreenVisible(true)
  }, [])

  const onClosePopupScreen = useCallback(() => {
    setIsPopupScreenVisible(false)
  }, [])

  return {
    isPopupScreenVisible,
    onOpenPopupScreen,
    onClosePopupScreen,
  }
}
